export const TYPE_DOCUMENT_PROCESSO_VERBALE = '999';
